import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {MatSort, MatSortHeader, Sort} from '@angular/material/sort';
import {TestResultsDataSource} from '../../../data/source/TestResultsDataSource';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-test-results-table',
  templateUrl: './test-results-table.component.html',
  styleUrls: ['./test-results-table.component.css']
})
export class TestResultsTableComponent implements OnInit, OnChanges {

  @Input() testId!: number;
  @Input() displayedColumns!: string[];
  @Input() dataSource!: TestResultsDataSource;
  @Input() pageSizeOptions!: number[];
  @Input() pageSize!: number;
  @Input() pageNumber!: number;
  @Input() sort!: any[];

  @ViewChild(MatSort) matSort!: MatSort;
  @ViewChild(MatPaginator) matPaginator!: MatPaginator;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sort && this.matSort) {
      const sort = changes.sort.currentValue;
      (this.matSort.sortables.get(sort[0]) as MatSortHeader)
        ._setAnimationTransitionState({toState: 'active'});
    }
  }

  public get sort$(): Observable<Sort> {
    return this.matSort.sortChange.asObservable();
  }

  public get page$(): Observable<PageEvent> {
    return this.matPaginator.page.asObservable();
  }

}
